import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, Loader2, Mail } from "lucide-react";
import { ADMIN_API } from "./api";
import { parseApiError } from "../lib/apiError";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const r = await axios.post(`${ADMIN_API}/login`, { email, password: pw });
      localStorage.setItem("kl_admin_token", r.data.token);
      nav("/admin");
    } catch (e) {
      setErr(parseApiError(e, "Login failed"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7] text-slate-900 flex items-center justify-center p-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl border border-slate-200 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.15)] p-10">
        <div className="flex items-center gap-3 mb-1">
          <span className="w-9 h-9 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center">
            <Lock className="w-4 h-4 text-amber-600" />
          </span>
          <p className="font-sans text-[10px] uppercase tracking-[0.22em] text-amber-700">Admin</p>
        </div>
        <h1 className="font-serif text-3xl text-slate-900 mt-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Kama <span className="italic text-amber-700">Loka</span> Journeys dashboard
        </h1>
        <p className="mt-2 text-sm text-slate-500">Sign in with your administrator credentials.</p>

        <label className="block mt-8">
          <span className="text-[11px] uppercase tracking-[0.22em] text-slate-500">email</span>
          <div className="relative mt-2">
            <Mail className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
            <input
              data-testid="admin-email-input"
              type="email"
              autoFocus
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 bg-white focus:outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-100 text-base"
            />
          </div>
        </label>

        <label className="block mt-4">
          <span className="text-[11px] uppercase tracking-[0.22em] text-slate-500">password</span>
          <div className="relative mt-2">
            <Lock className="w-4 h-4 text-slate-400 absolute left-3.5 top-1/2 -translate-y-1/2" />
            <input
              data-testid="admin-password-input"
              type="password"
              autoComplete="current-password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 bg-white focus:outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-100 text-base"
            />
          </div>
        </label>

        {err && <p className="mt-3 text-sm text-red-600" data-testid="admin-login-error">{err}</p>}

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="mt-8 w-full py-3.5 rounded-full bg-slate-900 text-white text-sm font-medium uppercase tracking-[0.18em] hover:bg-slate-800 disabled:opacity-60 flex items-center justify-center gap-2"
        >
          {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Verifying</> : "Sign in"}
        </button>

        <a href="/" className="block text-center mt-5 text-xs text-slate-400 hover:text-slate-600">← back to site</a>
      </form>
    </div>
  );
}
